var React = require('react');

function FilesIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#eeca8f"},[React.createElement("path",{"d":"m9 34.5v-30c0-2.4853125 2.0146875-4.5 4.5-4.5h19.5v9h9v25.5c0 2.4853125-2.0146875 4.5-4.5 4.5h-24c-2.4853125 0-4.5-2.0146875-4.5-4.5z","opacity":".4","key":0}),React.createElement("path",{"d":"m4.5 40.5v-31.5c-2.4853125 0-4.5 2.0146875-4.5 4.5v28.5c0 3.313125 2.6859375 6 6 6h22.5c2.4853125 0 4.5-2.015625 4.5-4.5h-25.5c-1.6569375 0-3-1.3434375-3-3zm28.5-40.5v9h9z","key":1})]));
}

FilesIcon.defaultProps = {"height":"48","viewBox":"0 0 42 48","width":"42"};

module.exports = FilesIcon;

FilesIcon.default = FilesIcon;
